module.exports = "<div class=\"exculsive-memeber-message\" *ngIf=\"isExclusive\">\n    <h2>this offer is exclusive to {{ partnerName }} members</h2>\n  <div class=\"exclusive-stars\">\n    <i class=\"far fa-star first-star\"></i>\n    <i class=\"far fa-star second-star\"></i>\n    <i class=\"far fa-star third-star\"></i>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-member-message/resort-member-message.component.html
// module id = ../../../../../src/app/resort-detail/resort-member-message/resort-member-message.component.html
// module chunks = main